@if ({}; as STATE) {
  <section class="ads-type-creation-dialog">
    <ads-type-creation-form [adsType]="adsType()" />
  </section>
}
